import api from './api';
import { RequestMethod } from '@/legacy/types';
import { AxiosRequestConfig, AxiosResponse, ResponseType as AxiosResponseType } from 'axios';

export * from './dashboardService';

export const getMethod = (method: RequestMethod) => {
	switch (method) {
		case 'GET':
			return api.get;
		case 'POST':
			return api.post;
		case 'PUT':
			return api.put;
		case 'PATCH':
			return api.patch;
		case 'DELETE':
			return api.delete;
		default:
			return api.get;
	}
};

type FetchRequestParams = {
	url: string;
	method?: RequestMethod;
	data?: any;
	queryParams?: Record<string, any>;
	responseType?: AxiosResponseType;
	headers?: Record<string, string>;
};

export const fetchRequest = async <TOutput>({
	url,
	method = 'GET',
	data,
	queryParams = {},
	responseType = 'json',
	headers,
}: FetchRequestParams): Promise<AxiosResponse<TOutput>> => {
	const config: AxiosRequestConfig = {
		url,
		method: method as RequestMethod,
		params: queryParams,
		data,
		responseType,
		headers,
	};
	return api.request<TOutput>(config);
};
